import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../services/auth/authSlice';
import botReducer from '../services/bot/botSlice';
import sidebarReducer from '../app/chat/sidebar/sidebarSlice';
import layoutReducer from '../services/layout/layoutSlice';
import translateSlice from './translate/translate-slice';
import { initLang, initTexts } from './translate/translate-actions';

const store = configureStore({
  reducer: {
    bot: botReducer,
    auth: authReducer,
    sidebar: sidebarReducer,
    layout: layoutReducer,
    translate: translateSlice.reducer,
  },
});

store.dispatch(initLang()).then(() => {
  store.dispatch(initTexts());
});

export default store;
